import get from 'lodash/get';
import { feedBack } from '../actionTypes';

const startFetchingFeedBackListData = () => ({
  type: feedBack.START_FETCHING_FEEDBACK_DATA
});

const successFetchingFeedBackListData = payload => ({
  type: feedBack.SUCCESS_FETCHING_FEEDBACK_DATA,
  payload
});

const errorFetchingFeedBackListData = payload => ({
  type: feedBack.FAILURE_FETCHING_FEEDBACK_DATA,
  payload
});

export const clearFetchingFeedBackListData = payload => ({
  type: feedBack.CLEAR_FETCHING_FEEDBACK_DATA,
  payload
});


export const fetchFeedBackListData = (currentPage, filters) => (dispatch, getState) => {

  dispatch(clearFetchingFeedBackListData());
  dispatch(startFetchingFeedBackListData());

  const { field_name, direction } = getState().sortReducer;

  dispatch({
    hmsFetchConfig: {
      path: '/hms_ms/api/v1/generic/campaign_page_widgets_v2',
      method: 'POST',
      queryParams: {
        page_type: 'medallia_feed_back_list',
        campaign: 'data',
        clear_cache: true
      },
      body: {
        page: currentPage - 1,
        sort: {
          field_name,
          direction
        },
        filters
      }
    },

    onSuccess: ({ data }) => {
      const feedback_list_data = get(data, 'data.widget_list[0]', []);
      dispatch(successFetchingFeedBackListData({ feedback_list_data }));
    },

    onError: ({ error }) => {
      dispatch(errorFetchingFeedBackListData({ error }));
    }
  });
};
